import { borderRadius, Icon, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { CardType } from '../../StreamCard';

export const IconWrapper = styled.div<{
  $isRead: boolean;
  $type: CardType;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${borderRadius.rFull};
  padding: 2px;
  width: 16px;
  height: 16px;
  background-color: ${({ $isRead, $type }) =>
    $isRead
      ? 'var(--surface-default)'
      : {
          [CardType.CompanyCatalyst]: 'var(--surface-decorative-lime-default)',
          [CardType.MarketCatalyst]: 'var(--surface-decorative-cyan-default)',
          [CardType.MarketSummary]: 'var(--surface-decorative-gold-default)',
          [CardType.Scenario]: 'var(--surface-decorative-indigo-default)',
          [CardType.EarningsPreview]:
            'var(--surface-decorative-purple-default)',
          [CardType.EarningsRecap]: 'var(--surface-decorative-teal-default)',
        }[$type] || 'var(--surface-default)'};
`;

export const TitleLabel = styled.div<{
  $isRead?: boolean;
  $type?: CardType;
}>`
  ${typographyV2.uiXs};
  color: ${({ $isRead, $type }) => {
    if ($isRead) {
      return 'var(--text-soft)';
    }

    switch ($type) {
      case CardType.MarketCatalyst:
        return 'var(--text-decorative-cyan)';
      case CardType.MarketSummary:
        return 'var(--text-decorative-gold)';
      case CardType.Scenario:
        return 'var(--text-decorative-indigo)';
      case CardType.EarningsPreview:
        return 'var(--text-decorative-purple)';
      case CardType.EarningsRecap:
        return 'var(--text-decorative-teal)';
      default:
        return $type === CardType.CompanyCatalyst
          ? 'var(--text-decorative-lime)'
          : 'var(--text-decorative-cyan)';
    }
  }};
  white-space: nowrap;
`;

export const StyledPillWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const StyledScenarioIcon = styled(Icon)<{ $isRead: boolean }>`
  > path {
    fill: ${props =>
      props.$isRead ? 'var(--icon-soft)' : 'var(--icon-decorative-indigo)'};
  }
`;

export const StyledEarningsPreviewIcon = styled(Icon)<{ $isRead: boolean }>`
  > path {
    fill: ${props =>
      props.$isRead ? 'var(--icon-soft)' : 'var(--icon-decorative-purple)'};
  }
`;

export const StyledEarningsRecapIcon = styled(Icon)<{ $isRead: boolean }>`
  > path {
    fill: ${props =>
      props.$isRead ? 'var(--icon-soft)' : 'var(--icon-decorative-teal)'};
  }
`;

